import React, { useEffect } from 'react';
import { FaTimes, FaHeadset } from 'react-icons/fa';
import { CardOverlay, SupportCardContainer, CardHeader, CardTitle, CloseButton, CardBody } from '../styles/supportStyles';
import { SupportCardContent } from './SupportCardContent';

export const SupportCard = ({ isOpen, onClose }) => {
  // Bloqueia o scroll da página de fundo enquanto o modal está aberto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <CardOverlay onClick={onClose}>
      <SupportCardContainer onClick={(e) => e.stopPropagation()}>
        <CardHeader>
          <CardTitle>
            <FaHeadset />
            <h2>Ajuda e Suporte</h2>
          </CardTitle>
          <CloseButton onClick={onClose}>
            <FaTimes />
          </CloseButton>
        </CardHeader>
        <CardBody>
          <SupportCardContent />
        </CardBody>
      </SupportCardContainer>
    </CardOverlay>
  );
};